import { useRef, useState } from 'react'

// One send or retry at a time, checked fresh on each: the balance can flip mid-session.
export function useGretaAIChatSubmit({ activeChatIdRef, balance }) {
  const [isSendPending, setIsSendPending] = useState(false)
  const isSendPendingRef = useRef(false)

  async function submit(action) {
    if (!isSendPendingRef.current) {
      isSendPendingRef.current = true
      setIsSendPending(true)

      const submittedChatId = activeChatIdRef.current

      try {
        const isBlocked = balance.isLocked || (await balance.checkBalance())

        if (!isBlocked && activeChatIdRef.current === submittedChatId) {
          action(submittedChatId)
        }
      } finally {
        isSendPendingRef.current = false
        setIsSendPending(false)
      }
    }
  }

  return { isSendPending, submit }
}
